import { reducer, initialStateBase } from './newCollection';

export const urls = {};

const initialState = Object.assign({}, initialStateBase, {
    metadataKey: 'messages'
});

export default (state = initialState, action) => {
    switch (action.type) {
        case 'LOGOUT':
            return initialState;
        default:
            return reducer(state, action, 'MESSAGES');
    }
};
